import { useQuery } from '@tanstack/react-query';

import type { HitType } from '@/components/Search/Hit.types';

import { TYPESENSE_COLLECTION } from '../constants';

export type Status = 'pending' | 'error' | 'success';

export const getTypesenseDocumentById = async (
  sku: string,
): Promise<HitType> => {
  const url = `https://${process.env.GATSBY_TYPESENSE_HOST}:${process.env.GATSBY_TYPESENSE_PORT}/collections/${TYPESENSE_COLLECTION}/documents/${sku}`;
  const options = {
    method: 'GET',
    headers: {
      'X-Typesense-Api-Key': process.env.GATSBY_TYPESENSE_SEARCH_KEY,
    },
  };

  try {
    const resp = await fetch(url, options);
    if (!resp.ok) {
      throw Error(resp.statusText);
    }
    const json = await resp.json();
    return json;
  } catch (err) {
    console.log(err);
  }
};

export const useTypesenseDocumentById = ({
  sku,
}: {
  sku: string;
}): {
  status: Status;
  error: null | unknown;
  data: HitType;
} => {
  const { status, error, data } = useQuery({
    queryKey: ['typesense', sku],
    queryFn: async () => getTypesenseDocumentById(sku),
    staleTime: 1000 * 60 * 60,
  });

  return { status, error, data };
};
